import React from "react";
import { connect } from "react-redux";
import { SubmissionError } from "redux-form";
import { movil } from "../../app-movil";
import { callService, formatDateDMA, goTo } from "../../tools";
import { agregarPoliza } from "../../home/polizas.act";
import PolizaForm from "../../home/poliza.frm";
import PolizaFormWebMovil from "../../home/polizaWebMovil.frm";
import Modal from '../../generalcomponets/modal-mobile'


const mapState = (state) => {
	return {
		clienteUnico: state.global.clienteUnico,
		loading: state.global.loading,
		uid: state.global.uid,
		mostraratras: state.polizasMovil.mostraratras
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		agregarPoliza: sDatos => {
			dispatch(agregarPoliza(sDatos));
		},
		alerta: (sTitulo, sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnClose });
		},
		mostrarMensajePolizaAgregada: (sTitulo, sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": sTitulo, "mensaje": sMensaje });
		}
	};
};

const limpiar = (value) => {
	return (value != undefined)? value.replace(/\s/g, "").toUpperCase() : "";
};

class AgregarPolizaMovil extends React.Component {
	
	state = {
		isModalOpened: false,
		modalMesage:{type: null, title: null, message: null},
		redirect: false
	}

	submit = (data) => {
		let $this = this;
		let hoy = new Date();
		$this.props.loader(true);
		
		let poliza = data.poliza1;
		if(data.sistema == "INFO") {
			while (poliza.length < 14) {
				poliza = "0" + poliza;
			}
		}

		if(data.polizaReal && parseInt(data.poliza) != parseInt(data.polizaReal)){
			data.poliza = data.polizaReal;
		}
		
		agregarPoliza({
			"clienteUnico": this.props.clienteUnico,
			"poliza": poliza,
			"ramo": data.ramo1,
			"vigencia": formatDateDMA(data.iniVigenciaDate),
			"sistemaOrigen": data.sistema,
			"canal": "APP",
			"certificado": data.certificado,
			"estatus": "Pendiente",
			"grupo": (data.grupo)?"Grupo":"Individual",
			"solicitud": formatDateDMA(hoy.getTime()),
			"fecha": hoy.getTime(),
			//"timestamp": formatDateDMA(hoy.getTime()) + " " + hoy.toISOString().split("T")[1].substr(0,8)
			"timestamp": formatDateDMA(hoy.getTime()) + " " + hoy.toLocaleTimeString()
		}).then(resultado => {
			console.log(resultado);
			$this.props.loader(false);
			let titulo = "Solicitud recibida";
			let descripcion = "En un plazo de 72 horas deberas consultar nuevamente tu información. IMPORTANTE: No podrás consultar las pólizas donde no te encuentres como Contratante o Asegurado.";
			// $this.props.alerta(titulo, descripcion, () =>{
			// 	console.log($this.props.mostraratras)
			// 	if($this.props.mostraratras) {
			// 		$this.goBack();	
			// 	} else {
			// 		movil("enviarToken",{"proceso":"","return":"miPerfil"});
			// 	}	
			// });
			this.openModalParent('success',titulo,descripcion,true);
		}).catch(error => {
			console.log(error);
			$this.props.loader(false);
			if(error.message.mensaje){
				// $this.props.mostrarMensajePolizaAgregada("Importante", error.message.mensaje);
				this.openModalParent('error',"Importante", error.message.mensaje);
				// this.setState({
				// 	isModalOpened: true,
				// 	modalMesage:{type: 'error', title: "Importante", message: error.message.mensaje}
				// });
			} else {
				// $this.props.mostrarMensajePolizaAgregada("ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
				this.openModalParent('error',"ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
				// this.setState({
				// 	isModalOpened: true,
				// 	modalMesage:{type: 'error', title: "Error", message: "Lo sentimos, podrias intentarlo nuevamente."}
				// });
			}
		});
	}

	goBack = () => {
		let mensaje = {"return": "home"};
		movil("", mensaje);
		// goTo("movil/polizas");
		//window.location.href = '/#!/movil/polizas';
	}

	openModalParent = (type, title, message, red = false) => {
		let { isModalOpened } = this.state;

		if (isModalOpened)
			this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null }, errorAndRedirect: false })
		else {
			this.setState({ isModalOpened: true, modalMesage:{ type, title, message}, redirect: red ? red: false });
		}
	}

	closeModalFromChild = () => {
		if(this.state.redirect){
			this.goBack();
		} else 
			this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null } });
	}
	
	render() {
		return (
			<div className="" >
				<PolizaFormWebMovil onSubmit={this.submit} goBack={this.goBack} loaded={true} />

				{/*<PolizaForm mobile={true} mostraratras={this.props.mostraratras} onSubmit={this.submit} goBack={this.goBack} loaded={this.props.uid} />*/}
				{this.state.isModalOpened &&
					<Modal closeModalFromChild={this.closeModalFromChild}>
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
										{this.state.modalMesage.type === "error" ? <img src={require('../../img/verified_user_success.svg')} alt="Error image modal" className="gnp-material-comtent-image" /> : <img src={require('../../img/verified_user_success.svg')} alt="Success image modal" className="gnp-material-comtent-image" />}
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal">{this.state.modalMesage.title}</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									<p className=" gnp-material-content-modal">{this.state.modalMesage.message}</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.closeModalFromChild} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</Modal>}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(AgregarPolizaMovil);


// WEBPACK FOOTER //
// ./src/movil/polizas/agregarPolizas.cmpt.js